import React from "react";
import { Link, NavLink } from "react-router-dom";
import BrandMark from "@/components/ventrix/Logo";
import { Menu, X, Search } from "lucide-react";

export function PublicHeader() {
  const [open, setOpen] = React.useState(false);
  const links = [
    { to: "/track", label: "Track" },
    { to: "/quote", label: "Instant quote" },
    { to: "/services/air", label: "Services" },
    { to: "/about", label: "About" },
  ];
  return (
    <header className="sticky top-0 z-50 bg-[#F4FEFF]/85 backdrop-blur-xl border-b border-[#A9C0E0]/40">
      <div className="vtx-container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-link">
          <BrandMark size={30} />
          <div className="leading-tight">
            <div className="font-black text-[#0E2F76] text-[15px] tracking-tight">VENTRIX</div>
            <div className="text-[9px] tracking-[0.14em] text-[#475569] font-semibold">GLOBAL FREIGHTS LTD</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors ${
                  isActive ? "text-[#d41f26]" : "text-[#0f172a] hover:text-[#0E2F76]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <Link to="/login" className="text-sm font-semibold text-[#0E2F76] hover:text-[#d41f26]" data-testid="header-login">Sign in</Link>
          <Link to="/register" className="vtx-btn-primary" data-testid="header-register">Open account</Link>
        </div>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#A9C0E0]/40 bg-white">
          <div className="vtx-container py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm font-semibold text-[#0f172a]" onClick={() => setOpen(false)}>
                {l.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2">
              <Link to="/login" className="vtx-btn-ghost flex-1 text-center" onClick={() => setOpen(false)}>Sign in</Link>
              <Link to="/register" className="vtx-btn-primary flex-1 text-center" onClick={() => setOpen(false)}>Open account</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="border-t border-[#A9C0E0]/40 bg-white mt-24">
      <div className="vtx-container py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <BrandMark size={30} />
            <div>
              <div className="font-black text-[#0E2F76] text-[15px]">VENTRIX</div>
              <div className="text-[9px] tracking-[0.14em] text-[#475569] font-semibold">GLOBAL FREIGHTS LTD</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-[#475569] leading-relaxed max-w-xs">
            Enterprise freight forwarding across air, sea and road — with tracking your operations team can trust.
          </p>
        </div>
        <FooterCol title="Services" links={[
          ["Air freight", "/services/air"], ["Sea freight", "/services/sea"],
          ["Road freight", "/services/road"], ["Warehousing", "/services/warehousing"],
          ["Customs", "/services/customs"], ["Last-mile", "/services/last-mile"],
        ]} />
        <FooterCol title="Product" links={[
          ["Track a shipment", "/track"], ["Instant quote", "/quote"],
          ["Customer portal", "/login"],
        ]} />
        <FooterCol title="Company" links={[
          ["About Ventrix", "/about"], ["Contact ops", "/contact"],
          ["Security & compliance", "/security"], ["Careers", "/careers"],
        ]} />
      </div>
      <div className="border-t border-[#A9C0E0]/40">
        <div className="vtx-container py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#475569]">
          <div>© {new Date().getFullYear()} Ventrix Global Freights Ltd. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/terms" className="hover:text-[#d41f26]">Terms</Link>
            <Link to="/privacy" className="hover:text-[#d41f26]">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="vtx-eyebrow mb-4">{title}</div>
      <ul className="space-y-2.5">
        {links.map(([label, href]) => (
          <li key={label}>
            <Link to={href} className="text-sm text-[#0f172a] hover:text-[#d41f26]">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
